import React, { Fragment } from "react";

import Header2 from "../../components/Header2/Header2";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import CtaSection from "../../components/CtaSection/CtaSection";
import { HelmetProvider } from "react-helmet-async";
import SEO from "../../components/SEO";
import ContactSection from "../../components/ContactSection";

const ContactPage = (props) => {
  return (
    <Fragment>
      <SEO
        title="Contact Uinifed Consulting Services - Get in Touch for Software & Consulting Solutions"
        description="Reach out to Unified Consulting Services for expert technical consulting, software solutions, and HR services. We're here to support your business and career growth. Contact us today."
        url="https://www.ufsnetworks.com/contact"
        image="https://texora.s3.ap-south-1.amazonaws.com/ufs_logo.jpg"
        canonicalUrl="https://www.ufsnetworks.com/contact"
      />
      <Header2 />
      <main className="page_content about-page">
        <PageTitle
          pageTitle={"Contact Unified Consultancy Services"}
          pagesub={"Us"}
          pageTop={"Contact"}
        />
        {/* <div className="whatsAppFixed" style={{position:"fixed", right:"26px", bottom:"100px", zIndex:"9999"}}>
            <a className="hotline_block" style={{padding:"0px"}} href="https://wa.me/+919210970334?text=Hello%2C%20I%20would%20like%20to%20know%20more%20about%20your%20services" target="_blank" >
              <span className="hotline_icon" style={{width:"46px", height:"46px"}}>
                <i className="fa-brands fa-whatsapp fa-bounce" style={{fontSize:"26px"}}></i>
              </span>
            </a>
        </div> */}
        <ContactSection />
        <CtaSection />
      </main>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default ContactPage;
